import { render, staticRenderFns } from "./CopaymentField.vue?vue&type=template&id=50e7c700&scoped=true&"
import script from "./CopaymentField.vue?vue&type=script&lang=js&"
export * from "./CopaymentField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e7c700",
  null
  
)

export default component.exports